import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './app/hooks/useAuth';
import { useEffect } from 'react';

const HomePage: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.user != null) {
      navigate('/admin');
    }
  }, [auth, navigate]);

  return (
    <div className="h-[70vh] px-2 py-2 flex flex-col justify-center items-center text-center bg-[#E6E9EB]">
      <h1 className="mb-8">
        Engaging <span className="text-primary">Loyalty</span> that Sticks.
      </h1>
      <hr />
      <p>
        When you’re thinking of creating a new exciting loyalty program, we’re the technology specialists you need to
        start, grow and win.
      </p>
      <Link data-cy="register-page-btn" to="/register">
        <button className="w-48 text-white mt-4 px-5 py-2 rounded-3xl bg-[#1D8A43]">Let&apos;s Connect</button>
      </Link>
    </div>
  );
};

export default HomePage;
